import { ChangeDetectionStrategy, Component } from "@angular/core";
import { StrategyListComponent } from "@m19-board/strategies/strategy-list/strategy-list.component";

@Component({
  selector: "app-sp-manager",
  templateUrl: "./sp-manager.component.html",
  imports: [StrategyListComponent],
  host: {
    "[class.h-full]": "true",
    "[class.w-full]": "true",
    "[class.block]": "true",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpManagerComponent {}
